import { render, staticRenderFns } from "./user-data-permission.vue?vue&type=template&id=701c31e4&scoped=true"
import script from "./user-data-permission.vue?vue&type=script&lang=js"
export * from "./user-data-permission.vue?vue&type=script&lang=js"
import style0 from "./user-data-permission.vue?vue&type=style&index=0&id=701c31e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c31e4",
  null
  
)

export default component.exports